import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

//todo not working as open is getting set only on component mount
const CBackDrop = ({ cOpen, cHandleClose, zIndex }) => {
  return (
    <Backdrop
      open={cOpen}
      onClick={cHandleClose}
      sx={{
        color: "#FFFFFF",
        zIndex: (theme) =>
          zIndex ?? theme.zIndex.drawer + 1,
      }}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default CBackDrop;

